/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/DropdownList';
import CategoryItem from 'app/components/DropDownItems/CategoryItem.jsx';
import * as _ from 'underscore';

class CategoryChooser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            category: null
        };

        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.addCategory = this.addCategory.bind(this);

    }

    componentDidMount() {

        this.props.getCategories();

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.categories.length && _.isEmpty(this.state.categories)) {
            let categories = _.clone(this.props.categories);

            categories.unshift({
                'id': 0,
                'name': 'None',
                'color': '#888888'
            });

            this.setState({
                categories
            });
        }

    }

    onCategoryChange(category) {

        this.setState({
            category
        });

    }

    addCategory(e) {
        e.preventDefault();

        this.props.confirmAction(this.state.category);

    }

    render() {
        let tagID = '';

        if (this.props.serviceType !== undefined && this.props.serviceType > 0) {
            if (this.props.postData.services[this.props.serviceType] !== undefined && this.props.postData.services[this.props.serviceType].tagID !== undefined) {
                tagID = this.props.postData.services[this.props.serviceType].tagID;
            }
        } else if (this.props.postData.shared.tagID !== undefined) {
            tagID = this.props.postData.shared.tagID;
        }

        return (
            <div>
                <div className="pt-accessory-header">Add post to Category</div>
                <div className="pt-category-chooser">
                    <DropdownList
                        data={this.state.categories}
                        dataKey='id'
                        filter={false}
                        renderListItem={({ item }) => {
                            if (!_.isObject(item)) {
                                return;
                            }
                            return (
                                <CategoryItem
                                    item={item}/>
                            );
                        }}
                        renderValue={({ item }) => {
                            if (!_.isObject(item)) {
                                return;
                            }
                            return (
                                <CategoryItem
                                    item={item}/>
                            );
                        }}
                        defaultValue={tagID}
                        placeholder="Choose Category"
                        className="category-drop"
                        onChange={this.onCategoryChange} />

                    <div className="pt-info-text">
                        Categories only apply to items being added to a queue.
                    </div>
                </div>
                <div className="pt-accessory-actions">
                    <div role="button" aria-label="cancel delete" className="action-cancel" onClick={this.props.cancelAction}>
                        Go Back
                    </div>
                    <button type="button" className="btn-delete action-delete" onClick={this.addCategory}>
                        Add to Category
                    </button>
                </div>
            </div>
        );
    }
}

CategoryChooser.displayName = "CategoryChooser";

export default CategoryChooser;
